import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let id = useDataValue({
    context: 'report',
    path: 'last_execution.id',
    viewPath: props.viewPath,
  })

  return {
    variables: { id },
  }
}
